import React from "react";
import ReactDOM from "react-dom";
import InContentTools from "../../../ai_tools/InContentTools";

const UncachedAITool = (props) => {
  const content = <InContentTools {...props} />;
  const container = document.querySelector(
    "#poems-show__guide__ai-tool__container"
  );

  return ReactDOM.createPortal(content, container);
};

export default UncachedAITool;
